//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { serverURL } from '@/config'

export default {
  name: "FileSelect",
  props: ['value', 'label'],
  data() {
      return {
        url: null
    }
  },
  methods: {
    fileChanged(file) {
      let formData = new FormData();
      formData.append("image1", file);
      axios.post( `${ serverURL }/wp-json/s3m/v1/file_upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then(response => {
        let value = response.data.files[0];
        this.$emit("input", value)
      })
    },
    removeFile() {
      this.$emit("input", "")
    }
  },
  computed: {
    isImage() {
      return this.value.endsWith( '.png' )
          || this.value.endsWith( '.jpg' )
          || this.value.endsWith( '.jpeg' )
          || this.value.endsWith( '.webp' )
    }
  }
}
